/**
 * IntegrationsLiveCount — public "31 integrations · 9 live" counter.
 * Fetches once on mount from the public /integrations/summary endpoint and
 * degrades gracefully (hides itself if the endpoint fails). Goal: prove
 * product maturity at-a-glance on the landing page.
 */
import { useEffect, useState } from "react";
import { Zap } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const COPY = {
  pt: { total: "integrações nativas", live: "prontas para uso", soon: "em breve" },
  en: { total: "native integrations", live: "ready to use",     soon: "coming soon" },
  es: { total: "integraciones nativas", live: "listas para usar", soon: "próximamente" },
};

export default function IntegrationsLiveCount({ lang = "pt" }) {
  const [data, setData] = useState(null);
  const t = COPY[lang] || COPY.pt;

  useEffect(() => {
    fetch(`${API}/integrations/summary`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => d && setData(d))
      .catch(() => {});
  }, []);

  if (!data) return null;

  return (
    <div data-testid="integrations-live-count"
      className="flex flex-wrap items-center justify-center gap-3 mb-6">
      <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full"
        style={{ background: "rgba(201,162,78,0.10)", border: "1px solid rgba(201,162,78,0.35)" }}>
        <Zap className="w-3.5 h-3.5" style={{ color: "#C9A24E" }} />
        <span className="text-[11.5px] font-bold" style={{ color: "#F5F1E8" }}>
          <span className="text-[#C9A24E] font-extrabold">{data.total}</span>{" "}{t.total}
        </span>
      </div>
      <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full"
        style={{ background: "rgba(16,185,129,0.10)", border: "1px solid rgba(16,185,129,0.35)" }}>
        <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
        <span className="text-[11.5px] font-bold" style={{ color: "#F5F1E8" }}>
          <span className="text-emerald-400 font-extrabold">{data.live}</span>{" "}{t.live}
        </span>
      </div>
      {data.coming_soon > 0 && (
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full"
          style={{ background: "rgba(139,92,246,0.10)", border: "1px solid rgba(139,92,246,0.35)" }}>
          <span className="text-[11.5px] font-bold" style={{ color: "#F5F1E8" }}>
            <span className="text-[#A78BFA] font-extrabold">{data.coming_soon}</span>{" "}{t.soon}
          </span>
        </div>
      )}
    </div>
  );
}
